import React from 'react';
import { Type } from 'lucide-react';
import type { TextConfigProps } from './types';

export const TextConfiguration: React.FC<TextConfigProps> = ({ logoData, onChange }) => {
  return (
    <div className="bg-gray-50 rounded-lg p-4 space-y-4">
      <h3 className="font-medium text-gray-900 flex items-center space-x-2">
        <Type size={18} />
        <span>Text Logo</span>
      </h3>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">Logo Text</label>
        <input
          type="text"
          value={logoData.text || ''}
          onChange={e => onChange({ text: e.target.value })}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
          placeholder="Enter your brand name"
        />
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Size</label>
          <select
            value={logoData.textSize || 'medium'}
            onChange={e => onChange({ textSize: e.target.value as any })}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
          >
            <option value="small">Small</option>
            <option value="medium">Medium</option>
            <option value="large">Large</option>
            <option value="xl">Extra Large</option>
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Weight</label>
          <select
            value={logoData.textWeight || 'bold'}
            onChange={e => onChange({ textWeight: e.target.value as any })}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
          >
            <option value="light">Light</option>
            <option value="normal">Normal</option>
            <option value="bold">Bold</option>
          </select>
        </div>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">Color</label>
        <div className="flex items-center space-x-3">
          <input
            type="color"
            value={logoData.textColor || '#000000'}
            onChange={e => onChange({ textColor: e.target.value })}
            className="h-10 w-16 rounded border border-gray-300 cursor-pointer"
          />
          <input
            type="text"
            value={logoData.textColor || '#000000'}
            onChange={e => onChange({ textColor: e.target.value })}
            className="flex-1 px-3 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
            placeholder="#000000"
          />
        </div>
      </div>
    </div>
  );
};
